import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env';
import { SearchParams } from '@core/models/query-params/search-params.model';
import { IListResult } from '@core/interfaces/list-result/list-result.interface';
import { IVenueSource } from '@core/interfaces/venue/venue-source.interface';
import { IVenueListItem } from '@core/interfaces/venue/venue-list-item.interface';
import { EncodedHttpParams, HttpService } from '@interticket/core';
import { ICityInfo } from '../../interfaces/venue/city-info.interface';

@Injectable()
export class VenueSourceService implements IVenueSource {

  private readonly serviceVersion: string = environment.modules.core.venue.version;
  private readonly serviceBaseUrl: string = `/${this.serviceVersion}/venue`;

  constructor(
    private httpService: HttpService
  ) { }

  getList(searchParams?: SearchParams): Observable<IListResult<IVenueListItem>> {
    const params: HttpParams = searchParams ? searchParams.getHttpParams() : new EncodedHttpParams();
    return this.httpService.get<IListResult<IVenueListItem>>(`${this.serviceBaseUrl}/web/venue`, { params });
  }

  getCityByZipCode(zipCode: string): Observable<ICityInfo> {
    const params: EncodedHttpParams = new EncodedHttpParams().append('zipCode', `${zipCode}`);
    return this.httpService.get<ICityInfo>(`${this.serviceBaseUrl}/place/cityinfo`, { params });
  }

}
